module.exports = __webpack_public_path__ + "img/goal-four-en.d9c14540.png";